// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface SetGlobalPreReleaseRequest
 */
export interface SetGlobalPreReleaseRequest {
  /**
   *
   * @type {string}
   * @memberof SetGlobalPreReleaseRequest
   */
  note?: string;
}

/**
 * Check if a given object implements the SetGlobalPreReleaseRequest interface.
 */
export function instanceOfSetGlobalPreReleaseRequest(
  value: object,
): value is SetGlobalPreReleaseRequest {
  return true;
}

export function SetGlobalPreReleaseRequestFromJSON(
  json: any,
): SetGlobalPreReleaseRequest {
  return SetGlobalPreReleaseRequestFromJSONTyped(json, false);
}

export function SetGlobalPreReleaseRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetGlobalPreReleaseRequest {
  if (json == null) {
    return json;
  }
  return {
    note: json['note'] == null ? undefined : json['note'],
  };
}

export function SetGlobalPreReleaseRequestToJSON(
  json: any,
): SetGlobalPreReleaseRequest {
  return SetGlobalPreReleaseRequestToJSONTyped(json, false);
}

export function SetGlobalPreReleaseRequestToJSONTyped(
  value?: SetGlobalPreReleaseRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    note: value['note'],
  };
}
